var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconArrowSquareUpLeft = function SvgIconArrowSquareUpLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.992 8.45a1 1 0 0 1 .383-.075h4.5a1 1 0 1 1 0 2h-2.086l3.543 3.543a1 1 0 0 1-1.414 1.414l-3.543-3.543v2.086a1 1 0 1 1-2 0v-4.5c0-.275.111-.524.29-.705l.005-.004a1 1 0 0 1 .322-.215"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M19.5 2.75c.966 0 1.75.784 1.75 1.75v15a1.75 1.75 0 0 1-1.75 1.75h-15a1.75 1.75 0 0 1-1.75-1.75v-15c0-.966.784-1.75 1.75-1.75zm-.25 2H4.75v14.5h14.5z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconArrowSquareUpLeft;